import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-baja-operador",
  templateUrl: "./baja.component.html",
})
export class BajaOperadorFormModal implements OnInit {
  public form: FormGroup;
  public defaults?: any = undefined;

  @Output() onsave = new EventEmitter<{
    mode: string;
    value: BajaOperadorFormModal;
  }>();

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<BajaOperadorFormModal>
  ) {}

  public ngOnInit() {
    this.buildForm();
  }

  save() {
    const dataForm = this.form.value;
    this.dialogRef.close({
      ...dataForm,
    });
  }
  private buildForm() {
    this.form = this.fb.group({
      FechaBaja: ["", [Validators.required]],
      Razon: ["", [Validators.required]],
      Reingreso: [true],
    });
  }
}
